import { Box, Card, CardBody } from "@chakra-ui/react"
import { DashboardTeaser } from "./dashboard-teaser"

export const DashboardTeasers = () => {
  return (
    <>
      <Box flexBasis="50%">
          <DashboardTeaser
            title="97 LinkedIn Hook Templates for LinkedIn"
            link="https://taplio.notion.site/97-linkedin-hook-templates?pvs=4"
            backgroundImage="/assets/dashboard/hooks.png"
          />
      </Box>
      <Box flexBasis="50%">
          <DashboardTeaser
            title="21 Content Templates for LinkedIn by Charles Miller +130K subscribers"
            link="https://taplio.notion.site/21-highly-effective-content-templates-for-linkedin?pvs=4"
            backgroundImage="/assets/dashboard/charles.png"
          />
      </Box>
    </>
  )
}